var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 " },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container  mb-5" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row justify-content-center vaillantCont pb-5 pt-3" },
          [
            _c("div", { staticClass: "col-md-12 mt-4" }, [
              _vm.brand == "HAPPYBONUS"
                ? _c(
                    "a",
                    {
                      staticClass: "black underline h5",
                      attrs: {
                        href:
                          "https://storage.googleapis.com/happybonus/Guida_HappyBonus_Novembre_2021.pdf",
                        target: "_blank"
                      }
                    },
                    [
                      _c("b", [
                        _vm._v(
                          " Guida all’utilizzo della nuova web app HappyBonus ed. Novembre ’21 "
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.brand == "CHEBONUS"
                ? _c(
                    "a",
                    {
                      staticClass: "black underline h5",
                      attrs: {
                        href:
                          "https://storage.googleapis.com/chebonus/Guida_CheBonus_Novembre_2021.pdf",
                        target: "_blank"
                      }
                    },
                    [
                      _c("b", [
                        _vm._v(
                          " Guida all’utilizzo della nuova web app CheBonus ed. Novembre ’21 "
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center mb-3 " }, [
      _c("div", { staticClass: "col-md-12 mt-4" }, [
        _c("h2", { staticClass: " ", attrs: { type: "text" } }, [
          _vm._v(" Guida all'utilizzo e FAQ ")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d25b78e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d25b78e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/faq/index.vue
// module id = null
// module chunks = 